import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { FormWrapper, InnerScroller } from '@common/components/BookingForms';
import { HEADER_HEIGHT, STICKY_BAR_HEIGHT } from '@common/components/BookingForms/Modal/constants';

export const HeaderWrapper = styled('div')`
  margin-top: 37px;

  ${media.md`
    margin-top: 47px;
  `}
`;

export const StyledFormWrapper = styled(FormWrapper)`
  height: calc(100vh - ${HEADER_HEIGHT}px);

  ${media.md`
    height: calc(100vh - ${HEADER_HEIGHT}px - ${STICKY_BAR_HEIGHT}px);
  `}
`;

export const StyledInnerScroller = styled(InnerScroller)`
  height: calc(100vh - ${HEADER_HEIGHT}px);

  ${media.md`
    height: calc(100vh - ${HEADER_HEIGHT}px - ${STICKY_BAR_HEIGHT}px);
  `}
`;
